import { observer } from 'mobx-react-lite';

import SideBar from 'components/common/SideBar/SideBar';
import RoleForm from 'components/roles/RoleManagement/RoleForm/RoleForm';
import { RoleDto } from 'components/roles/roles.dto';
import { RoleDialogType } from 'components/roles/roles.enums';

interface RoleFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  initial?: RoleDto;
  title: string;
  dialogType: RoleDialogType;
}

const RoleFormDialog = observer(({ isOpen, onClose, initial, title, dialogType }: RoleFormDialogProps) => (
  <SideBar title={title} isOpen={isOpen} onClose={onClose}>
    <RoleForm roleDto={initial} onClose={onClose} dialogType={dialogType} />
  </SideBar>
));

export default RoleFormDialog;
